import React from 'react'
import { Button, ButtonText, Message, Root } from './AuthErrorFallback.styles'
import { useEffect } from 'react'
import { useState } from 'react'

const AuthErrorFallback = () => {
  const [displayMessage, setDisplayMessage] = useState('')

  useEffect(() => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const error = urlParams?.get('error')
    setDisplayMessage(error || '')
  }, [])

  return (
    <Root>
      <div style={{ fontSize: '1rem' }}>
        <p>Sorry! You may not be able to access because of one of the following possible reasons :</p>
        1. Network Issue. You can try again in some time
        <br />
        OR
        <br />
        2. You may not have the access. Please contact your team lead/manager to grant you the same.
      </div>
      <Message>{displayMessage}</Message>
      <Button
        onClick={() =>
          (window.location.href = 'https://auth-saml.corp.ackodev.com/auth/saml/login/?service=cx-journey-master')
        }
      >
        <ButtonText>Try Again</ButtonText>
      </Button>
    </Root>
  )
}

export default AuthErrorFallback
